export default __webpack_public_path__ + "static/media/rabbitPng.908a16b5.png";